import { oop_1_slidedeckTTR } from './SL24500Sprint01TTR.js'
import { oop_2_slidedeckTTR } from './SL24500Sprint02TTR.js'
import { oop_3_slidedeckTTR } from './SL24500Sprint03TTR.js'
import { oop_4_slidedeckTTR } from './SL24500Sprint04TTR.js'
import { oop_5_slidedeckTTR } from './SL24500Sprint05TTR.js'
import { oop_6_slidedeckTTR } from './SL24500Sprint06TTR.js'


export const _CPSC_24500_SLIDEDECK_TTR = [ oop_1_slidedeckTTR, oop_2_slidedeckTTR, oop_3_slidedeckTTR, oop_4_slidedeckTTR, oop_5_slidedeckTTR, oop_6_slidedeckTTR, null, null ]